import React from 'react';
import { DotLoader } from 'src';


export default function DemoDotLoader() {
  return(
    <div>
      <DotLoader />
    </div>
  );
}



// WEBPACK FOOTER //
// ./demo/src/components/routes/ItemView/components/DemoDotLoader.js